
module.exports = function($transitions, $state, AuthService) {
    "ngInject";

    $transitions.onBefore({}, function(transition) {
        //console.log(transition.to())

        // check if the state should be protected
        const targetPageData = transition.to().data;
        const transName = transition.to().name;
        const state = $state;

        if (targetPageData && targetPageData.protected) {
          let authenticated = AuthService.checkAuthenticated(()=>{
            //If not authenticated, return false at first
            //If session cookie is valid, I will get back here and
            //can retry going to the transition
            //If session cookie is not valid, the auth service will redirect to login
            state.go(transName)
          });

          if(!authenticated) {
            return false;
          }
        }

        return true;
    });

    $transitions.onSuccess({}, function(transition) {
      let topMenu = transition.to().data ? transition.to().data.topMenu : null;

      $('navbar span').removeClass("navHighlight");
      if(topMenu) {
        setTimeout(function(){$("navbar span:contains('" + topMenu + "')").first().addClass("navHighlight"); }, 200);
      }

      //scroll back to the top after transition...is there a better way to do this?
      setTimeout(function(){window.scrollTo(0, 0); }, 200);

      return true;
    });
}





// WEBPACK FOOTER //
// ./client/app/app.run.js